import { DashlaneLPSection } from 'components/dashlane/DashlaneLPSection'
import React from 'react'

export function DashlanePageSections() {
  return (
    <>
      <DashlaneLPSection section="section_accounts" extraProps={{ imagePlacement: 'right' }} />
      <DashlaneLPSection section="section_viruses" />
      <DashlaneLPSection section="section_vpn" extraProps={{ imagePlacement: 'right' }} />
      <DashlaneLPSection section="section_passwords" />
    </>
  )
}
